import React from "react";
import { Table, Button } from "reactstrap";

export default class TablaAulas extends React.Component {
  render() {
    if (!this.props.data) return null;

    return (
      <Table hover className="mb-0">
        <thead>
          <tr>
          
            <th className="text-center">Nombre</th>
            <th className="text-center">Codigo</th>
            <th className="text-center">Fecha Registro</th>
            <th className="text-center">Institucion</th>
            <th className="text-center">Usuarios</th>
          </tr>
        </thead>
        <tbody>
          {this.props.data.map((e, index) => {
            return (
              <tr key={e.id}>
                 
                <td className="text-center">{e.nombre}</td>

                <td className="text-center">{e.codigo}</td>
                <td className="text-center">
                  {new Date(e.fechaRegistro).toDateString()}
                </td>
                <td className="text-center">{e.institucion.nombre}</td>

                <td className="text-center">
                  <Button
                    className="mb-2 mr-2"
                    color="info"
                    onClick={() => this.props.onViewAula(e)}
                  >
                    Ver Usuarios
                    <span className="badge badge-light">
                      {e.alumnos.length}
                    </span>
                  </Button>
                </td>
              </tr>
            );
          })}
          <div>
            <nav
              aria-label="Page"
              className="d-flex w-100 justify-content-center  "
            >
              <ul className="pagination">
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(0)}
                >
                  <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span className="sr-only"> Pagina Anterior</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link">{this.props.page}</a>
                </li>
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(1)}
                >
                  <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span className="sr-only">Proxima Pagina</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Provincia/component/TableHover.js